import { render } from "./ItemProfileMainInfo.vue?vue&type=template&id=5d750eee&scoped=true"
import script from "./ItemProfileMainInfo.vue?vue&type=script&lang=ts"
export * from "./ItemProfileMainInfo.vue?vue&type=script&lang=ts"

import "./ItemProfileMainInfo.vue?vue&type=style&index=0&id=5d750eee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d750eee"

export default script